<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">{{title}}</h4>
</div>
<div class="modal-body" *ngIf="dataLoaded">
    <ng-container *ngFor="let title of titles; let i = index; let first = first">
        <h2 *ngIf="first">Current Title</h2>
        <h2 *ngIf="!first">Issue Date: {{title.titleIssuedDate | shortDate}}</h2>
        <fieldset>
            <div class="row" *ngIf="title">
                <div class="col-sm-3 mvd_form-group">
                    <label>Title Number</label>
                    <div class="mvd_form-control">{{title.titleNumber}}</div>
                </div>
                <div class="col-sm-1 mvd_form-group">
                    <label>State</label>
                    <div class="mvd_form-control">AZ</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Title Issue Date</label>
                    <div class="mvd_form-control">{{getFormattedTitleIssuedDate(title)}}</div>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>Title Source</label>
                    <div class="mvd_form-control">{{title.titleSourceTypeId | displayValue:titleSourceTypes}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Print Date</label>
                    <div class="mvd_form-control">{{title.titlePrintedDate | shortDate}}</div>
                </div>
            </div>
            <div class="row" *ngIf="title && title.odometerReading">
                <div class="col-sm-3 mvd_form-group">
                    <label>Odometer Reading</label>
                    <div class="mvd_form-control">{{title.odometerReading.odometerReading | number}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Miles/Kilometers</label>
                    <div class="mvd_form-control">{{title.odometerReading.odometerReadingUnitTypeID | displayValue:odometerReadingUnitTypes}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Reading Type</label>
                    <div class="mvd_form-control">{{title.odometerReading.odometerReadingTypeID | displayValue:odometerReadingTypes}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Reading Date</label>
                    <div class="mvd_form-control">{{title.odometerReading.odometerReadingDate | shortDate}}</div>
                </div>
            </div>
        </fieldset>
    </ng-container>
    <p class="mvd_alert--label" *ngIf="!titles || !titles.length">No title history information available.</p>
</div>